import React, { Component } from 'react';
import $ from "jquery";
import config from "../config";
import UserFieldsInventoryModal from "./UserFieldsInventoryModal";
import { ItemsGroupCodeModal, renderTableItemsProperties, ToolTip } from "./index";
import ConfirmModal from './confirmModal';
import { CURRENCY, SERVICE_RESPONSE, decodeText } from '../libs/utils/Const';
import { ItemsGroupCodeModel } from './NewOrder';
import { ApiClient } from '../libs/apiClient';

let apiClient = ApiClient.getInstance();

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};
let headers = [
    { title: '#' },
    { title: 'Nombre de la propiedad' }
];

class InventoryDataModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            items: [],
            propSelected: [],
            array: [],
            checklist: [],
            switch1: false,
            checkboxArray: (new Map()),
            showItemsGroupCodeModal: false,
            editGroupCodeModal: false,
            ListUgpCodes: [],
            ListOrdrIntrvl: [],
            newGroupCodeModel: new ItemsGroupCodeModel(),
            groupCodeAction: 1,
            listAccounts: [],
            showListAccountsModal: false,
            fieldUsed: '',
        };
        this.newModelCopy = '';
    }
    componentDidMount() {

        const { action } = this.state;
        const { inventoryModel } = this.props;
        let array = [];
        let array2 = [];
        for (let i = 1; i < 65; i++) {
            array.push({
                id: i,
                nombre: 'Artículos de propiedad ' + i
            });
            array2.push({
                id: i,
                value: false
            })
        }
        this.setState({
            checklist: array2,
            propSelected: array
        });
        this.checkConfigFields('userConfigFielsDA');
    }

    //############################################### FUNCTIONS ##########################################################
    closeModal = () => {
        const { action } = this.props;
        if (action === 1) {
            $('#InventoryData').modal('hide')
        } else {
            $('#InventoryData').modal('hide')
        }
    };
    openAction = () => {
        $('#InventoryData').on('hide.bs.modal', function () {
        });
    };

    checkConfigFields(userConfig) {
        let config = JSON.parse(localStorage.getItem(userConfig)) || null;
        for (const key in config) {
            this.hideOrDisableFields(config[key])
        }
    }

    hideOrDisableFields(field) {
        let element = document.getElementById(field.id);
        if (element !== null) {
            if (field.show === false) {
                element.classList.add('hidden');
            } else {
                element.classList.remove('hidden');
            }
            if (field.edit === false) {
                $("#" + field.id).find("input, button, submit, textarea, select").attr("disabled", "disabled");
                $("#" + field.id).find("a").addClass("disablehyper").click(function (e) { e.preventDefault(); });
                $("#" + field.id).find("input, button, submit, textarea, select").addClass("disable");
            } else {
                $("#" + field.id).find("input, button, submit, textarea, select").removeAttr("disabled");
                $("#" + field.id).find("a").removeClass("disablehyper").unbind("click");
                $("#" + field.id).find("input, button, submit, textarea, select").removeClass("disable");
            }
        }
    }


    sendModel = () => {
        const { sendModel, inventoryModel } = this.props;
        sendModel(inventoryModel);


    };
    acceptEditMode = () => {
        const { acceptEditMode, inventoryModel } = this.props;
        acceptEditMode(inventoryModel);
    };

    cancelEditMode = () => {
        const { inventoryModel, cancelEditMode } = this.props;
        cancelEditMode();
        this.setState({
            editMode: false,
        });
    };

    editMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    refreshModel = inventoryModel => {
        const { refreshModel } = this.props;
        refreshModel(inventoryModel);
    };


    renderEditButton = () => {
        const { action, writeAccess } = this.props;
        const { editMode } = this.state;

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;
        if (!user || user.FMB_Role !== 'admin1') {
            return (
                <div>
                </div>
            )
        }
        if (action === 2 && !editMode && writeAccess) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    openUserFields = () => {
        $('#userFieldsInventoryModal').modal('show');
    };

    renderSelector = () => {
        return (
            <div>
                <div className="form-group row navigation-tabs2 text-right" style={{ paddingRight: 73 }}>
                    <label htmlFor="txtCustomer" className="col col-form-label col-form-label-md text-right font-weight-bold">
                        <span className="d-none d-xl-inline">Campos de Usuario</span>
                        <span className="d-inline d-xl-none">Campos Usuario</span>
                    </label>
                    <button
                        type="button"
                        style={{
                            backgroundColor: 'transparent',
                            color: '#EABF28',
                        }}
                        className="btn "
                        onClick={this.openUserFields}>
                        <i className="fa fa-list" aria-hidden="true" />
                    </button>
                </div>
                <br></br><br></br>
            </div>
        );
    };

    changeSelectedFieldDocument = (event, index) => {
        const { inventoryModel, refreshModel, action } = this.props;
        switch (index) {
            case 0:
                inventoryModel.ItmsGrpCod = event.nativeEvent.target.value;
                break;
            case 1:
                inventoryModel.UgpEntry = event.nativeEvent.target.value;
                break;
            case 2:
                inventoryModel.PriceList = event.nativeEvent.target.value;

                let num = inventoryModel.PriceList;

                num = parseInt(num)
                // num = num+1;
                let Price = 0;
                for (let index = 0; index < inventoryModel.PricesList.length; index++) {
                    const element = inventoryModel.PricesList[index];
                    if (parseInt(element.PriceList) === num) {
                        Price = element.Price;
                    }
                }
                // if(action===2&& num >= 0){
                inventoryModel.itemPrice = Price;
                // }else{
                //     inventoryModel.itemPrice=0;
                // }

                break;
            case 3:
                inventoryModel.itemType = event.nativeEvent.target.value;
                break;
            default:
                break;
        }
        refreshModel(inventoryModel);
    };

    ChangeModelProp = (key, value) => {
        const { inventoryModel } = this.props;
        inventoryModel[key] = value;
        this.refreshModel(inventoryModel);
    }

    changeitemCode = event => {
        const { inventoryModel } = this.props;
        inventoryModel.ItemCode = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    };
    changeItemName = event => {
        const { inventoryModel } = this.props;
        inventoryModel.itemName = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    };
    changeForeingName = event => {
        const { inventoryModel } = this.props;
        inventoryModel.FrgnName = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    changeCommentsItem = event => {
        const { inventoryModel } = this.props;
        inventoryModel.UserText = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onchangeCodeBars = event => {
        const { inventoryModel } = this.props;
        inventoryModel.CodeBars = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }

    ChangeCheckBoxItem = (key) => {
        const { inventoryModel } = this.props;
        inventoryModel[key] = inventoryModel[key] === 'Y' ? 'N' : 'Y';
        this.refreshModel(inventoryModel);
    }
    onchangeItemPrice = event => {
        const { inventoryModel, action } = this.props;
        if (action === 2) {
            let priceList = inventoryModel.PriceList;

            inventoryModel.PricesList[priceList - 1].Price = event.nativeEvent.target.value;
        }
        inventoryModel.itemPrice = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    toggleDocumentSelected = (id, option) => {
        const { action, inventoryModel } = this.props;
        const { checklist } = this.state


        this.setState(state => {
            let checkboxArray = new Map(state.checkboxArray);
            checkboxArray.set(id, !checkboxArray.get(id)); // toggle
            return { checkboxArray };
        });
        let value = option
        checklist[id] = { id, value }

        inventoryModel.QryGroup = checklist;
        setTimeout(() => {
            const { checkboxArray } = this.state;
        }, 100);
        this.refreshModel(inventoryModel);
    };

    toggleDocumentSelectedAll = (option) => {
        const { inventoryModel } = this.props;
        const { propSelected, checklist } = this.state;
        let newCheckbox = (new Map());
        inventoryModel.QryGroup = propSelected;

        inventoryModel.QryGroup.map((register, index) => {
            newCheckbox.set(index, option)
            let value = option;
            checklist[index] = { index, value }
        });
        inventoryModel.QryGroup = checklist;
        this.setState({
            checkboxArray: newCheckbox
        });
        setTimeout(() => {
            const { checkboxArray } = this.state;
        }, 100);
        this.refreshModel(inventoryModel);
    };

    onchangeInvtryUom = event => {
        const { inventoryModel } = this.props;
        inventoryModel.invntryUom = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onchangeSalunitMsr = event => {
        const { inventoryModel } = this.props;
        inventoryModel.SalUnitMsr = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onchangePurPackUn = event => {
        const { inventoryModel } = this.props;
        inventoryModel.PurPackUn = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }



    onChangeSalUnitMsr = event => {
        const { inventoryModel } = this.props;
        inventoryModel.SalUnitMsr = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onChangeNumInSale = event => {
        const { inventoryModel } = this.props;
        inventoryModel.NumInSale = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }

    onChangeSalesUnitWeight = event => {
        const { inventoryModel } = this.props;
        const value = event.nativeEvent.target.value;
        if (isNaN(value) && value && value !== '') { return; }
        inventoryModel.SalesUnitWeight = value;
        this.refreshModel(inventoryModel);
    }

    validateSalesUnitWeight = () => {
        const { inventoryModel } = this.props;
        let value = inventoryModel.SalesUnitWeight;
        if (isNaN(value)) { value = 0; }
        inventoryModel.SalesUnitWeight = Number(value).toFixed(3);
        this.refreshModel(inventoryModel);
    }

    onChangeSalesWeightUnit = event => {
        const { inventoryModel } = this.props;
        inventoryModel.SalesWeightUnit = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }

    onChangeSalPackMsr = event => {
        const { inventoryModel } = this.props;
        inventoryModel.SalPackMsr = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onChangeSalPackUn = event => {
        const { inventoryModel } = this.props;
        inventoryModel.SalPackUn = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }

    onChangeBuyUnitMsr = event => {
        const { inventoryModel } = this.props;
        inventoryModel.BuyUnitMsr = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onChangeNumInBuy = event => {
        const { inventoryModel } = this.props;
        inventoryModel.NumInBuy = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onChangePurPackMsr = event => {
        const { inventoryModel } = this.props;
        inventoryModel.PurPackMsr = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }
    onChangePurPackUn = event => {
        const { inventoryModel } = this.props;
        inventoryModel.PurPackUn = event.nativeEvent.target.value;
        this.refreshModel(inventoryModel);
    }

    changeMangeForm = (value) => {
        const { action, inventoryModel } = this.props;
        const { editMode } = this.state;
        if (!value || (action === 2 && !editMode) || inventoryModel.OnHand) return;

        inventoryModel.ManSerNum = value === 'S' ? 'Y' : 'N';
        inventoryModel.ManBtchNum = value === 'B' ? 'Y' : 'N';

        this.refreshModel(inventoryModel);
    }


    renderTable = () => {
        const { view, action, inventoryModel, value } = this.props;
        const { checkboxArray, propSelected, editMode } = this.state;
        let newCheckbox = (new Map());


        newCheckbox = checkboxArray

        if (action === 2 && !editMode) {
            for (let i = 1; i < 65; i++) {
                inventoryModel.QryGroup[`qryGroup${i}`] === 'Y' ? newCheckbox.set(i - 1, true) : newCheckbox.set(i - 1, false)
            }
        }
        let checkbox = {
            data: newCheckbox,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
            renderChecbox: this.toogleDocumentCheked,
        }

        let table = renderTableItemsProperties(headers, propSelected, action, checkbox, editMode);
        return table;
    };

    handleSwitchChange = nr => () => {
        const { switch1 } = this.state;
        let switchNumbers = `switch${nr}`;
        this.setState({
            switch1: !this.state[switchNumbers]
        });
        // this.render();
    };

    refreshGroupCodeModel = newGroupCodeModel => {
        this.setState({
            newGroupCodeModel
        })
    };

    openItemsGroupCodeModal = async (ItmsGrpCod) => {
        const { enableSpinner, showAlert, ListItemsGroup } = this.props;
        const firstGroupCode = Array.isArray(ListItemsGroup) && ListItemsGroup.length > 0 ? ListItemsGroup[0] : null;

        enableSpinner(true);
        // CARGAR INFO INICIAL
        const datainitial = await apiClient.getDataiInitialGroupCode();

        if (datainitial.status === SERVICE_RESPONSE.SUCCESS) {
            await this.setState({
                ListUgpCodes: datainitial.data.getUgpCodes || [],
                ListOrdrIntrvl: datainitial.data.getIntrvl || [],
            });
        }
        // CARGAR INFO INICIAL

        if (ItmsGrpCod !== '' || firstGroupCode.ItmsGrpCod !== '') {

            let data = {
                ItmsGrpCod: ItmsGrpCod || firstGroupCode.ItmsGrpCod,
            }
            const details = await apiClient.getItemsGroupCode(data);

            enableSpinner(false);

            if (details.status === SERVICE_RESPONSE.SUCCESS) {
                let newGroupCodeModel = new ItemsGroupCodeModel();
                newGroupCodeModel = this.fillGroupCodeModel(newGroupCodeModel, details?.data ?? {});

                await this.setState({
                    showItemsGroupCodeModal: true,
                    newGroupCodeModel,
                    groupCodeAction: 2,
                });
                $('#itemsGroupCodeModal').modal('show');
            } else {
                showAlert({ type: 'error', message: details.message })
                return false
            }
        } else {
            enableSpinner(false);
            let newGroupCodeModel = new ItemsGroupCodeModel();
            await this.setState({
                showItemsGroupCodeModal: true,
                newGroupCodeModel,
            });
            $('#itemsGroupCodeModal').modal('show');
        }
    };

    fillGroupCodeModel = (model, data) => {

        model.ItmsGrpCod = data?.ItmsGrpCod || '';
        model.ItmsGrpNam = data?.ItmsGrpNam || '';
        model.UgpEntry = data?.UgpEntry || '';
        model.PlaningSys = data?.PlaningSys || '';
        model.PrcrmntMtd = data?.PrcrmntMtd || '';
        model.CompoWH = data?.CompoWH || '';
        model.OrdrIntrvl = data?.OrdrIntrvl || '';
        model.OrdrMulti = Number(data?.OrdrMulti || 0).toFixed(3);
        model.MinOrdrQty = Number(data?.MinOrdrQty || 0).toFixed(3);
        model.RuleCode = data?.RuleCode || '';
        model.LeadTime = data?.LeadTime || '';
        model.ToleranDay = data?.ToleranDay || '';
        model.InvntSys = data?.InvntSys || '';

        // CUENTAS
        model.ExpensesAc = data?.ExpensesAc || '';
        model.RevenuesAc = data?.RevenuesAc || '';
        model.BalInvntAc = data?.BalInvntAc || '';
        model.SaleCostAc = data?.SaleCostAc || '';
        model.TransferAc = data?.TransferAc || '';
        model.VarianceAc = data?.VarianceAc || '';
        model.PriceDifAc = data?.PriceDifAc || '';
        model.NegStckAct = data?.NegStckAct || '';
        model.DecreasAc = data?.DecreasAc || '';
        model.IncreasAc = data?.IncreasAc || '';
        model.ReturnAc = data?.ReturnAc || '';
        model.FrRevenuAc = data?.FrRevenuAc || '';
        model.FrExpensAc = data?.FrExpensAc || '';
        model.ExchangeAc = data?.ExchangeAc || '';
        model.BalanceAcc = data?.BalanceAcc || '';
        model.DecresGlAc = data?.DecresGlAc || '';
        model.IncresGlAc = data?.IncresGlAc || '';
        model.WipAcct = data?.WipAcct || '';
        model.WipVarAcct = data?.WipVarAcct || '';
        model.WipOffset = data?.WipOffset || '';
        model.StockOffst = data?.StockOffst || '';
        model.StokRvlAct = data?.StokRvlAct || '';
        model.StkOffsAct = data?.StkOffsAct || '';
        model.CostRvlAct = data?.CostRvlAct || '';
        model.CstOffsAct = data?.CstOffsAct || '';
        model.ExpClrAct = data?.ExpClrAct || '';
        model.StkInTnAct = data?.StkInTnAct || '';
        model.ShpdGdsAct = data?.ShpdGdsAct || '';
        model.ARCMAct = data?.ARCMAct || '';
        model.APCMAct = data?.APCMAct || '';
        model.ARCMFrnAct = data?.ARCMFrnAct || '';
        model.APCMFrnAct = data?.APCMFrnAct || '';

        return model;
    };

    newGroupCode = async () => {
        let newGroupCodeModel = new ItemsGroupCodeModel();

        await this.setState({
            newGroupCodeModel,
            groupCodeAction: 1,
            editGroupCodeModal: false,
        });
    };

    SendNewGroupCode = async (index = null) => {
        const { enableSpinner, showAlert } = this.props;
        const { newGroupCodeModel } = this.state;
        if (newGroupCodeModel.ItmsGrpNam === '') {
            showAlert({ type: 'error', message: 'El campo nombre de grupo de artículos no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.BalInvntAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de existencias" no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.PriceDifAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de diferencias de precio" no puede ir vacío.' });
            return;
        }

        enableSpinner(true);
        let data = {
            model: newGroupCodeModel,
        };
        // return
        let response = await apiClient.CreateNewGroupCode(data);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message });

            $('#itemsGroupCodeModal').modal('hide');
            this.CloseItemsGroupCodeModal();
        } else {
            showAlert({ type: 'error', message: response.message });
        }
        enableSpinner(false);
    };

    changeEditModeGroupCode = () => {
        this.setState({
            editGroupCodeModal: !this.state.editGroupCodeModal,
        });
    };

    UpdateGroupCode = async () => {
        const { enableSpinner, showAlert } = this.props;
        const { newGroupCodeModel } = this.state;

        if (newGroupCodeModel.ItmsGrpNam === '') {
            showAlert({ type: 'error', message: 'El campo nombre de grupo de artículos no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.BalInvntAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de existencias" no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.PriceDifAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de diferencias de precio" no puede ir vacío.' });
            return;
        }

        enableSpinner(true);
        let data = {
            model: newGroupCodeModel,
        };

        let response = await apiClient.UpdateGroupCode(data);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message });

            $('#itemsGroupCodeModal').modal('hide');
            this.CloseItemsGroupCodeModal();
        } else {
            showAlert({ type: 'error', message: response.message });
        }
        enableSpinner(false);
    };

    CloseItemsGroupCodeModal = async () => {
        $('#itemsGroupCodeModal').modal('hide');
        await this.setState({
            groupCodeAction: 1,
            showItemsGroupCodeModal: false,
            editGroupCodeModal: false,
        });
    };

    listCounts = async (field, data) => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const list = await apiClient.listAccounts(data);

        enableSpinner(false);
        if (list.status === SERVICE_RESPONSE.SUCCESS) {
            if (list?.data?.length === 1 ?? false) {
                this.handleOnChange(field, list?.data?.[0].AcctCode)
            } else {
                this.setState({
                    listAccounts: list?.data || [],
                    showListAccountsModal: true,
                    fieldUsed: field
                }, () => {
                    $('#AccountListModal').modal('show');
                })
            }
        } else {
            showAlert({ type: 'error', message: list.message })
        }
    };

    handleOnChange = (property, value) => {
        const { newGroupCodeModel } = this.state;

        const auxModel = { ...newGroupCodeModel }

        auxModel[property] = value;
        this.refreshGroupCodeModel(auxModel)
    };

    cleanData = async () => {
        await this.setState({
            listAccounts: [],
            showListAccountsModal: false,
            fieldUsed: ''
        });
    };

    //############################################### END FUNCTIONS ##########################################################


    //############################################### MODAL ##########################################################
    renderInventoryHeader = () => {
        const { action, inventoryModel, ListItemsGroup, ListUnitMeasuGroup, prices, view, Producers } = this.props;
        const { editMode } = this.state;
        let listItemsGroup = Array.isArray(ListItemsGroup) && ListItemsGroup.length > 0 ? ListItemsGroup : { ItmsGrpCod: '', ItmsGrpNam: 'Opcion' }
        // let listUnitMeasuGroup = Array.isArray(ListUnitMeasuGroup) && ListUnitMeasuGroup.length > 0 ? ListUnitMeasuGroup : { UgpCode: '', UgpName: 'Opcion' }
        return (
            // DATOS MAESTROS DE ARTÍCULO
            <div className="row">
                {/*PRIMER COLUMNA ARTICULOS*/}
                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE ARTÍCULO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Artículo</span>
                        </div>
                        <input type="text"
                            className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            value={inventoryModel.ItemCode || ''}
                            onChange={this.changeitemCode}
                            disabled={action === 2}
                            // disabled={true}
                            id="txtCardCode" />
                    </div>

                    {/*DESCRIPCION DE ARTICULO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descripción</span>
                        </div>
                        <input type=" text" className="form-control"
                            id="txtGroupCode"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.itemName || ''}
                            onChange={this.changeItemName}

                        />
                    </div>
                    {/*NOMBRE EXTRANJERO DE ARTICULO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Nombre Extranjero</span>
                                <span className="d-inline d-xl-none">Nombre Extranjero</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control"
                            id="txtGroupCode"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.FrgnName || ''}
                            onChange={this.changeForeingName}
                        />
                    </div>

                    {/*CLASE DE ARTICULOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Clase De Artículo</span>
                                <span className="d-inline d-xl-none">Clase Artículo</span>
                            </span>
                        </div>
                        <select className="form-control"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.itemType}
                            onChange={(event) => this.changeSelectedFieldDocument(event, 3)}>
                            <option value={'I'}>{'Artículos'}</option>
                            <option value={'L'}>{'Trabajo'}</option>
                            <option value={'T'}>{'Viaje'}</option>
                        </select>
                    </div>

                    {/*GRUPO DE ARTICULOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Grupo De Artículos</span>
                                <span className="d-inline d-xl-none">Grupo Artículos</span>
                            </span>
                        </div>
                        <button
                            type="button"
                            disabled={action === 2 && !editMode}
                            style={{ backgroundColor: 'transparent', color: '#EABF28', maxWidth: 50 }}
                            className="form-control"
                            onClick={() => this.openItemsGroupCodeModal(inventoryModel.ItmsGrpCod)}>
                            <i className="fa fa-arrow-right" aria-hidden="true" />
                        </button>
                        <select className="form-control"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.ItmsGrpCod}
                            onChange={(event) => this.changeSelectedFieldDocument(event, 0)}>
                            {listItemsGroup.map(option => {
                                return (
                                    <option value={option.ItmsGrpCod} key={'Group' + option.ItmsGrpCod}>{option.ItmsGrpNam}</option>
                                )
                            })}
                        </select>
                    </div>

                    {/*GRUPO DE UNIDADES DE MEDIDA DE ARTICULOS*/}
                    {/* <div className="form-group row " id="div1">
                        <label htmlFor="txtCustomerRefNo"
                               className="col-md-4 col-sm-12 col-form-label font-weight-bold">Grupo De Unidades De Medida:</label>
                        <div className="col-md-6 col-sm-12">
                           <select className="form-control"
                           value={inventoryModel.UgpEntry}
                           disabled={action === 2 && !editMode}
                                onChange={event => this.changeSelectedFieldDocument(event,1)}
                                >
                                {listUnitMeasuGroup.map( option =>{
                                   return (
                                   <option value={option.UgpEntry}>{option.UgpName}</option>
                                   )
                               })}

                            </select>
                        </div>
                    </div> */}


                    {/*LISTA DE PRECIOS*/}
                    {(action === 2 && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Lista De Precios</span>
                                    <span className="d-inline d-xl-none">Lista Precios</span>
                                </span>
                            </div>
                            <select className="form-control"
                                onChange={(event) => this.changeSelectedFieldDocument(event, 2)}>
                                {prices.map(price => {
                                    return (
                                        <option value={price.ListNum}>{price.ListName}</option>
                                    )
                                })}
                                <option value={0}>Último precio de compra</option>
                                <option value={-1} selected>Último precio determinado</option>
                            </select>
                        </div>)}

                </div>

                {/*SEGUNDA COLUMNA ARTICULOS*/}
                <div className="col-12 col-md-6">

                    {/*CODIGO DE BARRAS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Código De Barras</span>
                                <span className="d-inline d-xl-none">Código Barras</span>
                            </span>
                        </div>
                        <input type=" text" className="form-control"
                            id="txtGroupCode"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.CodeBars || ''}
                            onChange={this.onchangeCodeBars}
                        />
                    </div>
                    {/*PRECIOS*/}
                    {(action === 2 && !editMode) && (
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Precio unitario</span>
                                    <span className="d-inline d-xl-none">Precio unitario</span>
                                </span>
                            </div>
                            {/* {(action == 1 || (action == 2 && editMode)) ? */}
                            <input type=" text" className="form-control"
                                id="txtGroupCode"
                                disabled="true"
                                value={CURRENCY + formatNumber.new(inventoryModel.itemPrice)}
                            //onChange={this.onchangeItemPrice}
                            // onChange={event => this.onchangeItemPrice(event)}
                            />
                            {/*
                        //     :

                        //     <input type=" text" className="form-control"
                        //     id="txtGroupCode"
                        //     disabled={action === 2 && !editMode}
                        //     value={CURRENCY + formatNumber.new(inventoryModel.itemPrice)} 
                        //     />
                        // } */}

                        </div>)}
                    {/* Fabricante */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fabricante</span>
                        </div>
                        <select className="form-control"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.FirmCode}
                            onChange={(event) => this.ChangeModelProp('FirmCode', event.target.value)}>
                            {Producers.map(option => {
                                return (
                                    <option value={option.FirmCode} >{option?.FirmName ?? ''}</option>
                                )
                            })}
                        </select>
                    </div>

                    {/* ARTICULO DE VENTA O INVENTARIABLE */}
                    <div className="input-group mb-2">
                        <div className="col-12" style={{ marginTop: 20 }}>

                            <div className="font-weight-bold" style={{ fontSize: '1.3vh', marginTop: 0 }}>
                                <label>
                                    <input
                                        className='form-check-label'
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={inventoryModel?.InvntItem === 'Y' ? true : false}
                                        onChange={() => this.ChangeCheckBoxItem('InvntItem')}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Artículo de inventario
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: '1.3vh', marginTop: 0 }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={inventoryModel?.SellItem === 'Y' ? true : false}
                                        onChange={() => this.ChangeCheckBoxItem('SellItem')}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Artículo venta
                                </label>
                            </div>
                            <div className="font-weight-bold" style={{ fontSize: '1.3vh', marginTop: 0 }}>
                                <label>
                                    <input
                                        type="checkbox"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        checked={inventoryModel?.PrchseItem === 'Y' ? true : false}
                                        onChange={() => this.ChangeCheckBoxItem('PrchseItem')}
                                        style={{ marginRight: '5px' }}
                                    />{' '}
                                    Artículo de compra
                                </label>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderInventoryBody = () => {
        const { inventoryModel, action } = this.props;
        const { editMode, switch1 } = this.state;
        let newOrderModelItems = inventoryModel ? inventoryModel.wareHouses ? inventoryModel.wareHouses : [] : [];
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-datosVentas-Inventory"
                            data-toggle="tab"
                            href="#datosVentasGeneral"
                            role="tab"
                            aria-controls="datosVentasInventory"
                            aria-selected="true">
                            Datos de Ventas
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-datosCompras-Inventory"
                            data-toggle="tab"
                            href="#datosComprasGeneral"
                            role="tab"
                            aria-controls="datosCompras"
                            aria-selected="false">
                            Datos de Compras
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-Inventory"
                            data-toggle="tab"
                            href="#dataContenidoInventory"
                            role="tab"
                            aria-controls="dataContenidoInventory"
                            aria-selected="false">
                            Inventario
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Propiedades"
                            data-toggle="tab"
                            href="#dataPropiedades"
                            role="tab"
                            aria-controls="dataPropiedades"
                            aria-selected="false">
                            Propiedades
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/*Datos de Ventas*/}
                    <div className="container tab-pane active"
                        id="datosVentasGeneral"
                        role="datosVentas"
                        aria-labelledby="nav-profile-tab-General"
                    //  style={{maxHeight: 500}}
                    >
                        <div className="row pt-3">
                            {/*Primer columna*/}
                            <div className="col-12 col-md-6 mb-3">
                                {/*Nombre de U. de medida de V.*/}
                                <div className="input-group mb-3" id="IDSD0">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nombre de unidad de medida de ventas</span>
                                            <span className="d-inline d-xl-none">Unidad Medida Ventas</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.SalUnitMsr || ''}
                                        onChange={this.onChangeSalUnitMsr}
                                    />
                                </div>
                                {/*CANTIDAD POR PAQUETE*/}
                                <div className="input-group mb-3" id="IDSD1">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Artículos por unidad de ventas</span>
                                            <span className="d-inline d-xl-none">Artículos x Unidad Compra</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.SalPackUn || ''}
                                        onChange={this.onChangeSalPackUn}
                                    />
                                </div>
                                {/*UNIDAD DE MEDIDA*/}
                                <div className="input-group mb-3" id="IDSD2">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nombre de unidad de medida de embalaje</span>
                                            <span className="d-inline d-xl-none">Unidad Medida Embalaje</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.SalPackMsr || ''}
                                        onChange={this.onChangeSalPackMsr}
                                    />
                                </div>
                                {/*UNIDAD DE VENTAS*/}
                                <div className="input-group mb-3" id="IDSD3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Cantidad por paquete</span>
                                            <span className="d-inline d-xl-none">Cant Paquete</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}

                                        value={inventoryModel.NumInSale || ''}
                                        onChange={this.onChangeNumInSale}
                                    />
                                </div>

                            </div>
                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6">
                                {/*Peso de venta*/}
                                <div className="input-group mb-3" id="IDSD1">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="lblSalesWeight">
                                            <span className="d-none d-xl-inline">Peso de Venta</span>
                                            <span className="d-inline d-xl-none">Peso Venta</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtSalesWeight"
                                        disabled={action === 2 && !editMode}
                                        onChange={this.onChangeSalesUnitWeight}
                                        onBlur={this.validateSalesUnitWeight}
                                        value={inventoryModel.SalesUnitWeight || ''} />
                                </div>
                                {/*UNIDAD DE MEDIDA*/}
                                <div className="input-group mb-3" id="IDSD2">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="lblSalesUoM">
                                            <span className="d-none d-xl-inline">Unidad de medida</span>
                                            <span className="d-inline d-xl-none">Unidad Medida</span>
                                        </span>
                                    </div>
                                    <select
                                        className="form-control"
                                        disabled={action === 2 && !editMode}
                                        onChange={this.onChangeSalesWeightUnit}
                                        value={inventoryModel.SalesWeightUnit || ''} >
                                        <option value="">Selecciona una opción</option>
                                        <option value="1">mg</option>
                                        <option value="2">g</option>
                                        <option value="3">kg</option>
                                        <option value="4">Oz</option>
                                        <option value="5">Lb</option>
                                    </select>
                                </div>
                                {/*Gestión por Series y Lotes*/}
                                <div className="input-group mb-3" id="IDSD2">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="lblSalesUoM">
                                            <span className="d-none d-xl-inline">Artículo Gestionado por</span>
                                            <span className="d-inline d-xl-none">Gestionado por</span>
                                            {!!(action === 2 && editMode && inventoryModel.OnHand) && <ToolTip tips={[{ message: "Este valor solo puede ser editado sí el stock del artículo es cero" }]} position="up" width="200" />}
                                        </span>
                                    </div>
                                    <select
                                        className="form-control"
                                        disabled={(action === 2 && !editMode) || inventoryModel.OnHand}
                                        onChange={({ target: { value } }) => this.changeMangeForm(value)}
                                        value={inventoryModel.ManSerNum === 'Y' ? 'S' : (inventoryModel.ManBtchNum === 'Y' ? 'B' : 'N')} >
                                        <option value="N"> Ninguna </option>
                                        <option value="S"> Números de Serie</option>
                                        <option value="B"> Lotes </option>
                                    </select>
                                </div>
                                {/*EMPLEADO DE VENTAS*/}

                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Empleado Ventas</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={true}
                                               value={partnerModel.SlpName ? partnerModel.SlpName : ""}
                                               id="txtTel2"/>
                                    {(action == 1 || (action == 2 && editMode)) && (
                                        <button
                                            type="button"
                                            style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                            className="input-group-text"
                                            onClick={this.openEmployee}>
                                            <i className="fa fa-list" aria-hidden="true"/>
                                        </button>
                                    )}
                                </div> */}

                                {/*TERRITORIO*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Territorio</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={true}
                                               value={partnerModel.TerritoryName ? partnerModel.TerritoryName : ""}
                                               id="txtTel2"/>
                                    {(action == 1 || (action == 2 && editMode)) && (
                                        <button
                                            type="button"
                                            style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                            className="input-group-text"
                                            onClick={this.openTerritory}>
                                            <i className="fa fa-list" aria-hidden="true"/>
                                        </button>
                                    )}
                                </div> */}

                            </div>
                        </div>
                    </div>
                    {/*Datos de Compras*/}
                    <div className="container tab-pane fade"
                        id="datosComprasGeneral"
                        role="datoscontactperson"
                        aria-labelledby="nav-profile-tab-ContactPerson"
                    //  style={{maxHeight: 700}}
                    >
                        <div className="row pt-3">
                            {/*Primer columna*/}
                            <div className="col-12 col-md-6 mb-3">
                                {/*Nombre de U. de medida de V.*/}
                                <div className="input-group mb-3" id="IDPD0">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nombre de unidad de medida de compras</span>
                                            <span className="d-inline d-xl-none">Unidad Medida Compras</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.BuyUnitMsr || ''}
                                        onChange={this.onChangeBuyUnitMsr}
                                    />
                                </div>
                                {/*CANTIDAD POR PAQUETE*/}
                                <div className="input-group mb-3" id="IDPD1">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Artículos por unidad de compras</span>
                                            <span className="d-inline d-xl-none">Artículos x Unidad Compra</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.PurPackUn || ''}
                                        onChange={this.onChangePurPackUn}
                                    />
                                </div>
                                {/*UNIDAD DE MEDIDA*/}
                                <div className="input-group mb-3" id="IDPD2">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nombre de unidad de medida de embalaje</span>
                                            <span className="d-inline d-xl-none">Unidad Medida Embalaje</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.PurPackMsr || ''}
                                        onChange={this.onChangePurPackMsr}
                                    />
                                </div>
                                {/*UNIDAD DE VENTAS*/}
                                <div className="input-group mb-3" id="IDPD3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Cantidad por paquete</span>
                                            <span className="d-inline d-xl-none">Cant Paquete</span>
                                        </span>
                                    </div>
                                    <input type=" text" className="form-control"
                                        id="txtGroupCode"
                                        disabled={action === 2 && !editMode}
                                        value={inventoryModel.NumInBuy || ''}
                                        onChange={this.onChangeNumInBuy}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-md-6"></div>
                                {/*ID contacto*/}
                                {/* <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">ID Contacto</span>
                                </div>
                                    <input type=" text" 
                                    className="form-control"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000'
                                            }}
                                            disabled={(action == 2 && !editMode) ? true : false}
                                            value={contactPerson.Name ? contactPerson.Name : ""}
                                            onChange={this.changeIDContacto}
                                            id="txtTel2"/>
                            </div> */}

                                {/*changeFirstName*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.FirstName ? contactPerson.FirstName : ""}
                                               onChange={this.changeFirstName}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Título*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Título</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Title ? contactPerson.Title : ""}
                                               onChange={this.changeTitle}
                                               id="txtTel2"/>
                                </div> */}

                                {/*ID contacto*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Segundo Nombre</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.MiddleName ? contactPerson.MiddleName : ""}
                                               onChange={this.changeMiddleName}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Position*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Posición</span>
                                    </div>
                                        <input type=" text" className="form-control"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Position ? contactPerson.Position : ""}
                                               onChange={this.changePosition}
                                               id="txtTel2"/>
                                </div> */}

                                {/*LastName*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Apellido</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.LastName ? contactPerson.LastName : ""}
                                               onChange={this.changeLastName}
                                               id="txtTel2"/>
                                </div> */}


                                {/*Tel1*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Teléfono 1</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Tel1 ? contactPerson.Tel1 : ""}
                                               onChange={this.changeTel1}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Tel2*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Teléfono 2</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Tel2 ? contactPerson.Tel2 : ""}
                                               onChange={this.changeTel2}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Celular*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Celular</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Cellolar ? contactPerson.Cellolar : ""}
                                               onChange={this.changeCellolar}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Fax*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Fax</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Fax ? contactPerson.Fax : ""}
                                               onChange={this.changeFax}
                                               id="txtTel2"/>
                                </div> */}

                                {/*E_mail*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Email</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.E_MailL ? contactPerson.E_MailL : ""}
                                               onChange={this.changeE_mail}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Notes1*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Observaciones 1</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Notes1 ? contactPerson.Notes1 : ""}
                                               onChange={this.changeNotes1}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Notes2*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Observaciones 2</span>
                                    </div>
                                        <input type=" text" className="form-control btn-outline-secondary"
                                               style={{
                                                   backgroundColor: 'transparent',
                                                   borderColor: '#ced4da',
                                                   color: '#000'
                                               }}
                                               disabled={(action == 2 && !editMode) ? true : false}
                                               value={contactPerson.Notes2 ? contactPerson.Notes2 : ""}
                                               onChange={this.changeNotes2}
                                               id="txtTel2"/>
                                </div> */}

                                {/*Active*/}
                                {/* <div className="form-group row" id="div1">
                                    <label htmlFor="txtContactPerson"
                                           className="col-md-4 col-sm-12 col-form-label font-weight-bold">Activo: <input
                                        type="checkbox"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        id="cbox1"
                                        checked={contactPerson.Active == 'Y' ? true : false}
                                        onChange={this.changeActiveContact}/>
                                    </label>
                                    <div className="col-md-6 col-sm-12">

                                    </div>
                                </div> */}

                                {/*fijar como estandar*/}
                                {/* <div className="form-group row" id="div1">
                                    <label htmlFor="txtContactPerson"
                                           className="col-md-4 col-sm-12 col-form-label font-weight-bold">Fijar como
                                        estándar: </label>
                                    <div className="col-md-6 col-sm-12">
                                        {(action == 1 || (action == 2 && editMode)) && (
                                            <button
                                                type="button"
                                                style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                className="btn"
                                                onClick={this.changeContactDefault}>
                                                <i className="fas fa-check" aria-hidden="true"/>
                                            </button>
                                        )}

                                    </div>
                                </div> */}

                        </div>
                    </div>
                    {/*Inventario*/}
                    <div className="w-100 tab-pane fade"
                        id="dataContenidoInventory"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-ContenidoInventory"
                        style={{ maxHeight: 2000, paddingTop: 5 }}>
                        <div className="table-responsive">
                        <table
                            id="dataTableDocumentsInventory"
                            className="display w-100"
                            style={{ marginBottom: 40 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-column sticky-header" style={{ backgroundColor: '#d2ab24', textAlign: 'center' }}>
                                        Código de Almacén
                                    </td>
                                    <td className="sticky-header" style={{ maxWidth: 200, textAlign: 'center', backgroundColor: '#d2ab24' }}>
                                        Nombre del Almacén
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', textAlign: 'center' }}>

                                        <label className="switch" >
                                            En Stock
                                        </label>
                                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
                                        <label className="switch" id="IDIA0">
                                            <input type="checkbox"
                                                checked={switch1}
                                                onChange={this.handleSwitchChange(1)}
                                            />
                                            <span className="slider round"></span>
                                        </label>


                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', textAlign: 'center' }}>
                                        Costo del Artículo
                                    </td>
                                    <td
                                        className="sticky-header sticky-columns"
                                        style={{ backgroundColor: '#d2ab24' }}
                                    />
                                </tr>
                            </thead>
                            <tbody id="IDIA1">
                                {newOrderModelItems.map((Whs, index) => {
                                    if (Whs.OnHand > 0 && switch1) {
                                        return (
                                            <tr style={{ color: Whs.OnHand > 0 ? 'black' : 'red' }}>
                                                {/*Código de almacén*/}
                                                <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {Whs.WhsCode || ''}
                                                </td>
                                                {/* Nombre del Almacén*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {decodeText(Whs.WhsName)}
                                                </td>
                                                {/* En Stock*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {Whs.OnHand || 0}
                                                </td>
                                                {/* Costo de Arículo*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {CURRENCY + formatNumber.new(Whs.AvgPrice ? Whs.AvgPrice : 0)}
                                                </td>
                                            </tr>
                                        );
                                    }
                                    if (!switch1) {
                                        return (
                                            <tr style={{ color: Whs.OnHand > 0 ? 'black' : 'red' }}>
                                                {/*Código de almacén*/}
                                                <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    {Whs.WhsCode}
                                                </td>
                                                {/* Nombre del Almacén*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {decodeText(Whs.WhsName)}
                                                </td>
                                                {/* En Stock*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {Whs.OnHand}
                                                </td>
                                                {/* Costo de Arículo*/}
                                                <td
                                                    className="overflow-visible"
                                                    style={{ textAlign: 'center', maxWidth: 200 }}>
                                                    {CURRENCY + formatNumber.new(Whs.AvgPrice ? Whs.AvgPrice : 0)}
                                                </td>
                                            </tr>
                                        );
                                    }


                                })}


                            </tbody>
                        </table>
                    </div>
                    </div>
                    {/*Propiedades*/}
                    <div className="tab-pane fade"
                        id="dataPropiedades"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Propiedades">
                        <div className="row" id="IDDA1">
                            <div className="col-12 table-responsive">
                                {this.renderTable()}
                        </div>
                    </div>
                </div>

                </div>
            </div>
        )
    }

    renderInventoryFooter = () => {
        const { inventoryModel, action } = this.props;
        const { editMode } = this.state;
        return (
            <div className="row">

                <div className="col-12 col-md-6">

                    <label htmlFor="txtComments" className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                        Comentarios:
                    </label>
                    <div className="col-12" id="IDSD4">
                        <textarea
                            type="text"
                            className=" form-control btn-outline-secondary"
                            id="txtComments"
                            rows="4"
                            disabled={action === 2 && !editMode}
                            value={inventoryModel.UserText}
                            onChange={this.changeCommentsItem}
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                        />
                    </div>
                </div>
            </div>
        )

    }
    //############################################### END MODAL ##########################################################
    render() {
        const { action, inventoryModel, view, showAlert } = this.props;
        const { editMode, items,
            showItemsGroupCodeModal,
            ListUgpCodes,
            ListOrdrIntrvl,
            newGroupCodeModel,
            groupCodeAction,
            editGroupCodeModal,
            listAccounts,
            showListAccountsModal,
            fieldUsed,
        } = this.state;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="InventoryData"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <ConfirmModal />
                <UserFieldsInventoryModal
                    inventoryModel={inventoryModel}
                    action={action}
                    refreshModel={this.refreshModel}
                    view={view}
                    editMode={editMode}
                />
                {showItemsGroupCodeModal &&
                    <ItemsGroupCodeModal
                        action={groupCodeAction}
                        CloseDocumentModal={this.CloseItemsGroupCodeModal}
                        newGroupCodeModel={newGroupCodeModel}
                        ListUgpCodes={ListUgpCodes}
                        ListOrdrIntrvl={ListOrdrIntrvl}
                        refreshModel={this.refreshGroupCodeModel}
                        showAlert={showAlert}
                        editMode={editGroupCodeModal}
                        newGroupCode={this.newGroupCode}
                        SendNewGroupCode={this.SendNewGroupCode}
                        changeEditModeGroupCode={this.changeEditModeGroupCode}
                        UpdateGroupCode={this.UpdateGroupCode}

                        listCounts={this.listCounts}
                        listAccounts={listAccounts}
                        showListAccountsModal={showListAccountsModal}
                        cleanData={this.cleanData}
                        fieldUsed={fieldUsed}
                    />
                }

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS MAESTROS DE ARTÍCULO</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                            {this.renderSelector()}
                            {this.renderEditButton()}
                            {this.renderInventoryHeader()}
                            {this.renderInventoryBody()}
                            {this.renderInventoryFooter()}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>
                                Cerrar
                            </button>
                            {action === 1 &&
                                <button type="button"
                                    className="btn botonCorrect text-black"
                                    onClick={this.sendModel}>
                                    Crear
                                </button>}
                            {action == 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}
                            {action == 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}

export default InventoryDataModal;